/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { OPACITY_INACTIVE, OPACITY_LINE } from './constants';
import { MeshBasicMaterial, LineBasicMaterial, DoubleSide, LineDashedMaterial } from 'three';
const defaultMaterialParams = {
    depthTest: false,
    depthWrite: false,
    fog: false,
    opacity: OPACITY_INACTIVE,
    transparent: true,
};
export const createMaterial = (params) => () => new MeshBasicMaterial(Object.assign({}, defaultMaterialParams, { side: DoubleSide }, params));
export const createLineMaterial = (params) => () => new LineBasicMaterial(Object.assign({}, defaultMaterialParams, { linewidth: 1, opacity: OPACITY_LINE }, params));
export const createDashedLineMaterial = (params) => () => new LineDashedMaterial(Object.assign({}, defaultMaterialParams, { linewidth: 1, opacity: OPACITY_LINE }, params));
//# sourceMappingURL=createMaterials.js.map